const langHomeCountDown = {
	title: {
		tag: 'home.count_down.title',
		fr: 'Le portail Sienna IM sera bientôt disponible',
		en: 'Sienna IM Portal is coming soon',
	},
	label_days: {
		tag: 'home.count_down.label_days',
		fr: 'jours',
		en: 'days',
	},
	label_hours: {
		tag: 'home.count_down.label_hours',
		fr: 'heures',
		en: 'hours',
	},
	label_minutes: {
		tag: 'home.count_down.label_minutes',
		fr: 'minutes',
		en: 'minutes',
	},
	label_seconds: {
		tag: 'home.count_down.label_seconds',
		fr: 'secondes',
		en: 'seconds',
	},
};

export default langHomeCountDown;
